export function similarity(s1, s2) {
  let longer = s1;
  let shorter = s2;
  if (s1.length < s2.length) {
    longer = s2;
    shorter = s1;
  }
  const longerLength = longer.length;
  if (longerLength === 0) {
    return 1.0;
  }
  return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength);
}

/*
 * Track the highest number of matching words
 */
export function similarityByWords(arrayToSearch, nameSearch) {
  let highestMatchCount = 0;
  let phraseBySimilarity = null;

  arrayToSearch.forEach(url => {
    const urlName = url.toLowerCase().split('/').pop().split('.')[0];
    const searchWords = nameSearch.toLowerCase().split(' ');
    const urlWords = urlName.split('-').join(' ').split(' '); // Adjusted splitting logic for your URLs

    let matchCount = searchWords.reduce((count, word) => {
      return count + (urlWords.includes(word) ? 1 : 0);
    }, 0);

    //console.log("urlName", urlName);
    //console.log("matchCount", matchCount);
    if (matchCount > highestMatchCount) {
      phraseBySimilarity = url;
      highestMatchCount = matchCount;
    }
  });

  return phraseBySimilarity
}

export function similarityByWordsExtended(arrayToSearch, nameSearch) {
  const sim = similarityByWordsArray(arrayToSearch, nameSearch);

  if (sim.length === 1 || sim.length && sim[0].matchCount === nameSearch.split(/\s+/).length) {
    return sim[0].url;
  }

  if (sim.length > 1) {
    const refined = refineByDashSegment(sim, nameSearch);
    if (refined) return refined;
    return sim[0].url;
  }
}

export function similarityByWordsArray(arrayToSearch, nameSearch) {
  const words = nameSearch
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);

  const matches = arrayToSearch
    .map(url => {
      const urlName = url
        .toLowerCase()
        .split('/')
        .pop()
        .split('.')[0];
      const urlWords = urlName.split(/[\s\-]+/).filter(Boolean);
      const matchCount = words.reduce(
        (c, w) => c + (urlWords.includes(w) ? 1 : 0),
        0
      );
      return { url, matchCount, urlName };
    })
    .filter(e => e.matchCount > 0)
    .sort((a, b) => b.matchCount - a.matchCount);

  return matches; // [{url,matchCount,urlName}, …]
}

/**
 * Selects the most suitable from matches.url by segments between '-'
 *
 * @param {{url:string, matchCount:number, urlName:string}[]} matches
 * @param {string} nameSearch
 * @returns {string|null}
 */
export function refineByDashSegment(matches, nameSearch) {
  const words = nameSearch
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);

  // 1) We look for the first URL that has a segment of the form "-word-",
  // where word is exactly one of the searched words
  for (const { urlName, url } of matches) {
    const segments = urlName.split('-').map(s => s.trim());
    const hasExactSingle = segments.some(seg => {
      const parts = seg.split(/\s+/).filter(Boolean);
      return parts.length === 1 && words.includes(parts[0]);
    });
    if (hasExactSingle) {
      return url;
    }
  }

  // 2) Fallback: among all segments, we count which one has the most matching words
  let bestUrl = null;
  let bestScore = -1;

  for (const { urlName, url } of matches) {
    const segments = urlName.split('-').map(s => s.trim());
    for (const seg of segments) {
      const cnt = seg
        .split(/\s+/)
        .filter(Boolean)
        .reduce((c, w) => c + (words.includes(w) ? 1 : 0), 0);

      if (cnt > bestScore) {
        bestScore = cnt;
        bestUrl = url;
      }
    }
  }

  return bestUrl;
}

function editDistance(s1, s2) {
  s1 = s1.toLowerCase();
  s2 = s2.toLowerCase();

  const costs = [];
  for (let i = 0; i <= s1.length; i++) {
    let lastValue = i;
    for (let j = 0; j <= s2.length; j++) {
      if (i === 0) costs[j] = j;
      else {
        if (j > 0) {
          let newValue = costs[j - 1];
          if (s1.charAt(i - 1) !== s2.charAt(j - 1)) newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
          costs[j - 1] = lastValue;
          lastValue = newValue;
        }
      }
    }
    if (i > 0) costs[s2.length] = lastValue;
  }
  return costs[s2.length];
}

export const isSqftPassedDataEmpty = (sqftPassedData) => {
  if (sqftPassedData && sqftPassedData.manualCalculate === false) {
    return sqftPassedData.countertops.length === 0
  } else if (sqftPassedData && sqftPassedData.manualCalculate === true) {
    return sqftPassedData.countertops.length === 0
      || sqftPassedData.backsplashes.length === 0
      || sqftPassedData.edges.length === 0
  }
  return false
}

// Function to group URLs by version and sort them in descending order by version number
export function groupUrlsByVersion(urls) {
  // Create an array to store versioned URLs
  const versionedUrls = [];

  urls.forEach(url => {
    // Extract the version number from the URL (if present)
    const versionMatch = url.match(/ar-composer(?:-v(\d+))?/);
    // If no version is present, default to version 1
    const version = versionMatch && versionMatch[1] ? parseInt(versionMatch[1], 10) : 1;

    // Add the version and URL to the array as an object
    versionedUrls.push({ version, url });
  });

  // Sort the array by version in descending order
  versionedUrls.sort((a, b) => b.version - a.version);

  // Return an array of sorted URLs based on version
  return versionedUrls.map(item => item.url);
}
